import React from 'react';
import Link from './Link';
import styled from 'styled-components';

import Logo from './Logo';
import FooterWidget, {
	FooterWidgetTitle,
	FooterWidgetContent,
} from './widgets/FooterWidget';

import breakpoints from '../styles/breakpoints';

const StyledFooter = styled.footer`
	background-color: ${p => p.theme.colors.footerBg};
	padding: 65px 0 15px 0;
`;

const Content = styled.div`
	max-width: ${p => p.theme.globalWidth};
	margin: 0 auto;
	padding: 0 ${p => p.theme.gutterSmall};

	${breakpoints.medium`
        adding: 0 ${p => p.theme.gutter};
    `};
`;

const Row = styled.div`
	text-align: center;

	${breakpoints.medium`
        text-align: left;
        display: flex;
    `};
`;

const Column = styled.div`
	flex: 1;
`;

const InnerRow = styled.div`
	${breakpoints.large`
        text-align: left;
        display: flex;
    `};
`;

const InnerColumn = styled.div`
	flex: 1;
`;

const Byline = styled.div`
	color: ${p => p.theme.colors.footerFont};
	text-align: center;
	padding: 30px 0 24px 0;
`;

const StyledLink = styled(Link)`
	color: ${p => p.theme.colors.footerFont};

	&:hover {
		color: ${p => p.theme.colors.footerFont};
		text-decoration: none;
	}
`;

const StyledALink = styled.a`
	color: ${p => p.theme.colors.footerFont};

	&:hover {
		color: ${p => p.theme.colors.footerFont};
		text-decoration: none;
	}
`;

export default function Footer() {
	return (
		<StyledFooter>
			<Content>
				<Row>
					<Column>
						<FooterWidget>
							<Logo width="140px" height="32px" color="#ffffff" />
						</FooterWidget>
					</Column>

					<Column>
						<InnerRow>
							<InnerColumn>
								<FooterWidget>
									<FooterWidgetTitle>
										Bil1Din AS
									</FooterWidgetTitle>

									<FooterWidgetContent>
										<p>
											Torvstrøveien 86
											<br />
											7860 Skage i Namdalen
										</p>

										<p>
											Telefon:{' '}
											<StyledALink href="tel:+4774282010">
												74 28 20 10
											</StyledALink>
											<br />
											E-post:{' '}
											<StyledALink href="mailto:post@bil1din.no">
												post@bil1din.no
											</StyledALink>
										</p>
									</FooterWidgetContent>
								</FooterWidget>
							</InnerColumn>

							<InnerColumn>
								<FooterWidget>
									<FooterWidgetTitle>
										Åpningstider
									</FooterWidgetTitle>

									<FooterWidgetContent>
										<p>
											Telefon / skriftlige henvendelser:
											<br />
											Man-fre: 08.00-16.00
										</p>
										<p>
											Nyhetsbrev:{' '}
											<StyledLink
												to="http://eepurl.com/gawSxT"
												target="_blank"
												rel="nofollow noopener">
												påmelding
											</StyledLink>
										</p>
									</FooterWidgetContent>
								</FooterWidget>
								<FooterWidget>
									<FooterWidgetContent />
								</FooterWidget>
							</InnerColumn>
						</InnerRow>
					</Column>
				</Row>

				<Byline>
					Bygget av{' '}
					<StyledALink
						href="https://smartmedia.no"
						target="_blank"
						rel="nofollow noopener">
						Smart Media AS
					</StyledALink>{' '}
					|{' '}
					<StyledLink to="/personvernerklaering/">
						Personvernerklæring
					</StyledLink>
				</Byline>
			</Content>
		</StyledFooter>
	);
}

//
